import { useOfferFiltersDispatch, useOfferFiltersState } from "../context/OfferFiltersContext";
import { toStringArray } from "../utils/buildQueryString";
import { useFilterTracking } from "../hooks/useFilterTracking";
import ImageCheckboxGrid from "./ImageCheckboxGrid";
import React from "react";
export default function BodyTypeCheckboxGrid({ filter, facet, }) {
    var _a;
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackFilterChange } = useFilterTracking();
    const param = filter.id;
    const current = toStringArray(selectedState[param]);
    const list = Object.values((_a = facet === null || facet === void 0 ? void 0 : facet.facet_data) !== null && _a !== void 0 ? _a : {});
    function handleToggle(value) {
        const arr = toStringArray(selectedState[param]);
        const next = arr.includes(value)
            ? arr.filter((v) => v !== value)
            : [...arr, value];
        trackFilterChange(filter, next);
        dispatch({
            type: "set_selected",
            payload: Object.assign(Object.assign({}, selectedState), { [param]: next.length ? next : undefined }),
        });
    }
    return (<ImageCheckboxGrid items={list} current={current} onToggle={handleToggle}/>);
}
